export default "__VITE_ASSET__d40b5588__"